<template>
  <human-nav current="trsr">
    <template #mainContent>
      <nii-show file-name="TR_S_R.nii.gz" container-id="trsr"></nii-show>
    </template>
  </human-nav>
</template>

<script>
import NiiShow from "@/components/xtk/niiShow";
import HumanNav from "@/components/public/humanNav";
export default {
  name: "trSr",
  components: {HumanNav, NiiShow}
}
</script>

<style scoped>

</style>